import engineerIcon from "../../static/sashimimochi2022.png";
import illustratorIcon from "../../static/illustrator.png";
import { FaGithub, FaBlog } from "react-icons/fa";
import { SiQiita, SiGmail, SiSpeakerdeck, SiZenn, SiX, SiPixiv } from "react-icons/si";
import { FadeInContainer } from "./AnimationTrigger";
import { TbArrowsExchange } from "react-icons/tb";

function LinkButton({ link }) {
  const icons = {
    x: <SiX />,
    gmail: <SiGmail />,
    qiita: <SiQiita />,
    hatena: <FaBlog />,
    github: <FaGithub />,
    speakerdeck: <SiSpeakerdeck />,
    zenn: <SiZenn />,
    pixiv: <SiPixiv />,
  };
  return (
    <a
      href={link.link}
      target="_blank"
      rel="noopener noreferrer"
      className={`link-button ${link.name}`}
    >
      {icons[link.name]}
    </a>
  );
}

function LinkButtons({ links }) {
  return (
    <>
      {links.map((link, _) => {
        return <LinkButton link={link} key={link.name} />;
      })}
    </>
  );
}

function ProfileCard({ portfolioMode, setPortfolioMode }) {
  const engineerLinks = [
    { name: "x", link: "https://x.com/Sashimimochi343" },
    { name: "gmail", link: "mailto:sashimimochi.clark&#64;gmail.com" },
    { name: "qiita", link: "https://qiita.com/Sashimimochi" },
    { name: "hatena", link: "https://t-n-clark.hatenadiary.jp/archive" },
    { name: "github", link: "https://github.com/Sashimimochi" },
    { name: "speakerdeck", link: "https://speakerdeck.com/sashimimochi" },
    { name: "zenn", link: "https://zenn.dev/sashimimochi" },
  ];

  const illustratorLinks = [
    { name: "x", link: "https://x.com/343mochi" },
    { name: "gmail", link: "mailto:sashimimochi343&#64;gmail.com" },
    { name: "pixiv", link: "https://www.pixiv.net/users/32386348" },
  ];

  const profileData = {
    engineer: {
      description: "普段は検索エンジンを触ったり自然言語処理をやっているものです",
      links: engineerLinks,
      icon: engineerIcon,
    },
    illustrator: {
      description: "ポニーテールをこよなく愛するアマチュアイラストレーター",
      links: illustratorLinks,
      icon: illustratorIcon,
    },
  };

  const currentProfile = profileData[portfolioMode];

  const handleFlip = () => {
    const newMode = portfolioMode === "engineer" ? "illustrator" : "engineer";
    setPortfolioMode(newMode);
  };

  return (
    <div>
      <div className={`card fadeIn ${portfolioMode === "illustrator" ? "flipped" : ""}`}>
        <div className="profile">
          <img src={currentProfile.icon} alt="Mochitto Caffe" className="icon" />
          <div className="name">
            <h1>さしみもち</h1>
          </div>
          <div className="description">
            <p>{currentProfile.description}</p>
          </div>
          {portfolioMode === "illustrator" && (
            <div className="illustrator-details">
              <p className="detail-line">
                CLIP STUDIO PAINT / Artist 15.6 Pro / Affinity Photo 2 / 色彩検定2級
              </p>
            </div>
          )}
          <LinkButtons links={currentProfile.links} />
          <div className="flip-button-container">
            <button
              onClick={handleFlip}
              className="flip-button"
              aria-label={`${portfolioMode === "engineer" ? "イラストレーター" : "エンジニア"}へ切り替え`}
            >
              <TbArrowsExchange /> {portfolioMode === "engineer" ? "イラストレーター" : "エンジニア"}へ切り替え
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Profile({ portfolioMode, setPortfolioMode }) {
  return <FadeInContainer component={<ProfileCard portfolioMode={portfolioMode} setPortfolioMode={setPortfolioMode} />} />;
}

export default Profile;
